import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PrimeNG } from 'primeng/config';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
    private primeng = inject(PrimeNG);
    private http = inject(HttpClient);

    ngOnInit(): void {
        this.primeng.ripple.set(true);

        const lang = localStorage.getItem('lang') || 'it';

        // Carica locale PrimeNG da assets e applicalo
        const primengLocaleUrl = `/assets/i18n/primeng/${lang}.json`;
        this.http.get(primengLocaleUrl).subscribe({
            next: dict => this.primeng.setTranslation(dict),
            error: err => console.warn('[PrimeNG] locale non caricato:', err)
        });
    }
}
